import { Button, Translator } from "@itarget/shared";
import React from "react";

export function BtnSeeMore(props) {
  return (
    <Button
      variant="midnight"
      icon="read_more"
      color="midnight"
      testId="action view-more"
      {...props}
    >
      <Translator transRef="translation.Veja mais" />
    </Button>
  );
}

BtnSeeMore.defaultProps = {
  onClick: null,
};

export function BtnWaitingList(props) {
  return (
    <Button
      variant="midnight"
      icon="read_more"
      color="midnight"
      testId="action waiting-list"
      {...props}
    >
      <Translator transRef="translation.Lista de espera" />
    </Button>
  );
}

BtnWaitingList.defaultProps = {
  onClick: null,
};

export function BtnAssistir(props) {
  return (
    <Button
      variant="midnight"
      icon="video_library"
      color="midnight"
      testId="action on-demand"
      {...props}
    >
      <Translator transRef="translation.On Demand" />
    </Button>
  );
}

BtnAssistir.defaultProps = {
  onClick: null,
};

export function BtnAssistirAoVivo(props) {
  return (
    <Button
      variant="midnight"
      icon="cast_for_education"
      color="midnight"
      testId="action live"
      {...props}
    >
      <Translator transRef="translation.Acessar ao vivo" />
    </Button>
  );
}

BtnAssistirAoVivo.defaultProps = {
  onClick: null,
};

export function BtnPendente(props) {
  return (
    <Button
      variant="midnight"
      icon="production_quantity_limits"
      color="midnight"
      testId="action my-purchases"
      {...props}
    >
      <Translator transRef="translation.Minhas compras" />
    </Button>
  );
}

BtnPendente.defaultProps = {
  onClick: null,
};

export function BtnInscrito(props) {
  return (
    <Button
      variant="midnight"
      icon="check"
      color="midnight"
      testId="action subscribed"
      {...props}
    >
      <Translator transRef="translation.Inscrito" />
    </Button>
  );
}

BtnInscrito.defaultProps = {
  onClick: null,
};

export function BtnMindsRadiology(props) {
  return (
    <Button
      variant="midnight"
      icon="link"
      color="midnight"
      testId="action minds-radiology"
      {...props}
    >
      <Translator transRef="translation.Minds Radiology" />
    </Button>
  );
}

BtnMindsRadiology.defaultProps = {
  onClick: null,
};

export function BtnAttendSeeClasses(props) {
  return (
    <Button
      variant="midnight"
      icon="video_library"
      color="midnight"
      testId="action view-classes"
      {...props}
    >
      <Translator transRef="translation.Ver aulas" />
    </Button>
  );
}
